import api from './api';

function unwrapPayload(data) {
  if (!data || typeof data !== 'object') return {};
  if (data.data !== undefined && data.data !== null && typeof data.data === 'object') {
    return data.data;
  }
  return data;
}

function buildParams(params = {}) {
  const query = {};
  const allowed = [
    'start_date',
    'end_date',
    'created_by_user_id',
    'status',
    'recipient_email',
    'template_id',
    'granularity',
    'sort',
    'direction',
    'page',
    'per_page',
    'limit',
  ];
  allowed.forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      query[key] = value;
    }
  });
  return query;
}

async function getOrgDashboard(path, params = {}) {
  const response = await api.get(path, { params: buildParams(params) });
  return unwrapPayload(response.data);
}

export const getOrgDashboardOverview = (params) =>
  getOrgDashboard('/organization/dashboard/overview', params);

export const getOrgDashboardTrends = (params) =>
  getOrgDashboard('/organization/dashboard/trends', params);

export const getOrgDashboardUsers = (params) =>
  getOrgDashboard('/organization/dashboard/users', params);

export const getOrgDashboardActionItems = (params) =>
  getOrgDashboard('/organization/dashboard/action-items', params);

export const getOrgDashboardActivity = (params) =>
  getOrgDashboard('/organization/dashboard/activity', params);

export const getOrgDashboardTeamSummary = (params) =>
  getOrgDashboard('/organization/dashboard/team-summary', params);

export const getOrgDashboardUserStats = (userId, params) =>
  getOrgDashboard(`/organization/dashboard/users/${userId}/stats`, params);

export const getOrgDashboardTemplates = (params) =>
  getOrgDashboard('/organization/dashboard/templates', params);

export const getOrgDashboardSigningMetrics = (params) =>
  getOrgDashboard('/organization/dashboard/signing-metrics', params);
